module.exports = __webpack_public_path__ + "static/img/advantages-4.0e03f52f.png";